var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoadingRing = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 130 130",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 64.728C2 30.084 30.084 2 64.728 2c34.644 0 62.728 28.084 62.728 62.728 0 34.644-28.084 62.728-62.728 62.728",
  stroke: "#88B04B",
  fill: "none"
})));
export default SvgLoadingRing;